import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class TabErrorService {
    private errors = new BehaviorSubject<{ [key: number]: boolean }>({});
    public errors$ = this.errors.asObservable();

    setError(tabIndex: number, hasError: boolean): void {
        const currentErrors = this.errors.value;
        currentErrors[tabIndex] = hasError;
        this.errors.next(currentErrors);
    }
}
